import { AD_ENTITY_TYPES, SERVICE_ACCOUNTS_ENTITY_IDENTIFIER_TYPES } from '@silverfort-nodelibs/common/utils/consts';
import { Icons } from '@silverfort/sf-components';

export const AdTypeOptions = {
    Servers: AD_ENTITY_TYPES.SERVER,
    Groups: AD_ENTITY_TYPES.GROUP,
    OUs: AD_ENTITY_TYPES.OU
};

export const ResourcesTypes = {
    Resources: 'resources',
    IPs: 'ips'
};

export const ACCOUNT_TYPE_TO_DISPLAY = [
    { title: 'Display name', value: 'display' },
    { title: 'Full path', value: 'full' }
];

export const AdTypeFilter = {
    id: 'type',
    title: 'Type',
    options: Object.keys(AdTypeOptions).map((optionKey) => ({
        title: optionKey,
        value: AdTypeOptions[optionKey]
    })),
    multiple: true,
    icon: Icons.ListFilter,
    variant: 'filter'
};

export const calcResourceIcon = (resource, isIp) => {
    if (isIp) {
        return Icons.IP;
    }

    switch (resource.type) {
        case AdTypeOptions.Groups: {
            return Icons.UserGroup;
        }
        case AdTypeOptions.OUs: {
            return Icons.Folder;
        }
        case AdTypeOptions.Servers: {
            return Icons.Server;
        }
        default: {
            break;
        }
    }
};

export const calcItemSubtitle = (item) => {
    if (item.identifier_type === SERVICE_ACCOUNTS_ENTITY_IDENTIFIER_TYPES.IP) {
        return 'IP Address';
    }
    if (item.guid || item.identifier_type === SERVICE_ACCOUNTS_ENTITY_IDENTIFIER_TYPES.GUID) {
        return `${item.domain_name ? `(${item.domain_name})` : ''}`;
    }
    if (item.identifier_type === SERVICE_ACCOUNTS_ENTITY_IDENTIFIER_TYPES.NAME) {
        return 'Hostname';
    }
};

export const calcItemTitle = (item, IPSelected, isFullPath = false) => {
    if (IPSelected) {
        return item;
    }

    const defaultTitle = item.name || item.identifier || 'N/A';
    let title = isFullPath ? item.path : defaultTitle;

    if (item.is_disabled) {
        title += ' (Disabled)';
    }
    return title;
};
